import { render, staticRenderFns } from "./PlanejamentoAcaoFormApuracaoExcecao.vue?vue&type=template&id=5d8ae15d&"
import script from "./PlanejamentoAcaoFormApuracaoExcecao.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAcaoFormApuracaoExcecao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
